import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class FiasToPostalCodeApi extends YoApi {

}

export default new FiasToPostalCodeApi({
	apiVersion: 'v2',
	endPoint: 'fiastopostalcode'
});

export function getFiasToPostalCodeApi (id) {
	return new FiasToPostalCodeApi({
		apiVersion: 'v2',
        endPoint: 'fiastopostalcode',
		itemId: id
	});
}
